import { render, staticRenderFns } from "./GeneralEvent.vue?vue&type=template&id=6b540306&scoped=true&"
import script from "./GeneralEvent.vue?vue&type=script&lang=js&"
export * from "./GeneralEvent.vue?vue&type=script&lang=js&"
import style0 from "./GeneralEvent.vue?vue&type=style&index=0&id=6b540306&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b540306",
  null
  
)

export default component.exports